enum DashboardsFilterType {
  multiselect
}

type DashboardsFilterOption {
  count: Int
  default: Boolean
  display: String
  value: String
}

type DashboardsFilterSchema {
  display_name: String
  param_name: String
  type: DashboardsFilterType
  values: [DashboardsFilterOption]
}

type DashboardsFilter {
  filters: [DashboardsFilterSchema]
}
